import type { InvivoLightingSettings, InvivoRenderSettings } from "../types/invivo_scene";

const LEGACY_DEFAULT_POSTPROCESS_PRESET = {
  globalExposure: -20.49,
  globalSaturation: 17.56,
  globalHue: 115.02,
  globalDensity: 0.73,
  highlightsExposure: 9.76,
  highlightsSaturation: -32.2,
  highlightsHue: 30,
  highlightsDensity: 0,
  midtonesExposure: -4.88,
  midtonesSaturation: 8.78,
  midtonesHue: 46.54,
  midtonesDensity: 5.67,
  shadowsExposure: -25.37,
  shadowsSaturation: 7.05,
  shadowsHue: 51.85,
  shadowsDensity: 1.22,
  exposure: 1.05,
  contrast: 1.09,
  sharpenColorAmount: 1.04,
  sharpenEdgeAmount: 0,
  bloomWeight: 0,
  grainIntensity: 0,
  grainAnimated: false,
  chromaticAberrationAmount: 0,
};

export function buildLegacyLightingSettings(): InvivoLightingSettings {
  return {
    hemisphericLightEnabled: false,
    environmentFollowsCamera: true,
    environmentYawOffset: 0,
    environmentPitchOffset: 0,
    environmentRollOffset: 0,
  };
}

export function buildLegacyRenderSettings(): InvivoRenderSettings {
  return {
    imageProcessing: {
      colorCurves: {
        globalExposure: LEGACY_DEFAULT_POSTPROCESS_PRESET.globalExposure,
        globalSaturation: LEGACY_DEFAULT_POSTPROCESS_PRESET.globalSaturation,
        globalHue: LEGACY_DEFAULT_POSTPROCESS_PRESET.globalHue,
        globalDensity: LEGACY_DEFAULT_POSTPROCESS_PRESET.globalDensity,
        highlightsExposure: LEGACY_DEFAULT_POSTPROCESS_PRESET.highlightsExposure,
        highlightsSaturation: LEGACY_DEFAULT_POSTPROCESS_PRESET.highlightsSaturation,
        highlightsHue: LEGACY_DEFAULT_POSTPROCESS_PRESET.highlightsHue,
        highlightsDensity: LEGACY_DEFAULT_POSTPROCESS_PRESET.highlightsDensity,
        midtonesExposure: LEGACY_DEFAULT_POSTPROCESS_PRESET.midtonesExposure,
        midtonesSaturation: LEGACY_DEFAULT_POSTPROCESS_PRESET.midtonesSaturation,
        midtonesHue: LEGACY_DEFAULT_POSTPROCESS_PRESET.midtonesHue,
        midtonesDensity: LEGACY_DEFAULT_POSTPROCESS_PRESET.midtonesDensity,
        shadowsExposure: LEGACY_DEFAULT_POSTPROCESS_PRESET.shadowsExposure,
        shadowsSaturation: LEGACY_DEFAULT_POSTPROCESS_PRESET.shadowsSaturation,
        shadowsHue: LEGACY_DEFAULT_POSTPROCESS_PRESET.shadowsHue,
        shadowsDensity: LEGACY_DEFAULT_POSTPROCESS_PRESET.shadowsDensity,
      },
      colorCurvesEnabled: true,
      exposure: LEGACY_DEFAULT_POSTPROCESS_PRESET.exposure,
      contrast: LEGACY_DEFAULT_POSTPROCESS_PRESET.contrast,
    },
    sharpen: {
      colorAmount: LEGACY_DEFAULT_POSTPROCESS_PRESET.sharpenColorAmount,
      edgeAmount: LEGACY_DEFAULT_POSTPROCESS_PRESET.sharpenEdgeAmount,
      enabled: true,
    },
    bloom: {
      weight: LEGACY_DEFAULT_POSTPROCESS_PRESET.bloomWeight,
      enabled: false,
    },
    grain: {
      intensity: LEGACY_DEFAULT_POSTPROCESS_PRESET.grainIntensity,
      animated: LEGACY_DEFAULT_POSTPROCESS_PRESET.grainAnimated,
      enabled: false,
    },
    chromaticAberration: {
      amount: LEGACY_DEFAULT_POSTPROCESS_PRESET.chromaticAberrationAmount,
      enabled: false,
    },
    depthOfFieldEnabled: false,
  };
}
